
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clanek/[...slug]",
      function () {
        return require("private-next-pages/clanek/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clanek/[...slug]"])
      });
    }
  